export class ResponseId {
    value = null;
    waiting = [];
    get() {
        if (this.value != null) {
            return Promise.resolve(this.value);
        }
        else {
            return new Promise((resolve) => {
                this.waiting.push(resolve);
            });
        }
    }
    set(value) {
        this.value = value;
        // Wait for the next tick before notifying the waiters
        setTimeout(() => {
            for (const waiter of this.waiting) {
                waiter(value);
            }
        }, 0);
    }
    toJSON() {
        return this.value != null ? this.value : "not yet available";
    }
}
export var EventTypes;
(function (EventTypes) {
    EventTypes["Search"] = "Search";
    EventTypes["ProductListing"] = "ProductListing";
    EventTypes["ProductClick"] = "ProductClick";
    EventTypes["ProductView"] = "ProductView";
    EventTypes["AddToCart"] = "AddToCart";
    EventTypes["Purchase"] = "Purchase";
})(EventTypes || (EventTypes = {}));
export function createResponseId() {
    return new ResponseId();
}
//# sourceMappingURL=event-types.js.map